import { t } from "i18next";
import {
    cloneAnswerStates,
    DEFAULT_ANSWER_PRESET,
    getAnswerTypePreset,
} from "./answerTypes";

export {
    answerTypePresets,
    applyAnswerType,
    mergeAnswerTypeOptions,
    resolveAnswerPresetId,
} from "./answerTypes";

export const createState = (value) => ({
    name: "",
    emoji: "",
    value,
});

export const createCriterion = () => {
    const preset = getAnswerTypePreset(DEFAULT_ANSWER_PRESET);
    return {
        name: "",
        weight: 1,
        answer_preset: preset.id,
        criteria_state_type: preset.criteria_state_type,
        add_description: false,
        add_upload_file: false,
        states: cloneAnswerStates(preset.states),
    };
};

export const createFormStructure = (name = "") => ({
    name,
    criteria: [createCriterion()],
});

export const criteriaTypeOptions = () => [
    { value: 1, label: t("criteria.type.numeral") },
    { value: 2, label: t("criteria.type.text") },
    { value: 3, label: t("criteria.type.emoji") },
    { value: 4, label: t("criteria.type.star") },
    { value: 5, label: t("criteria.type.range") },
];

/**
 * Strip read-only fields (ids, mandatory flags) so the structure matches the
 * strict backend FORM_STRUCTURE_SCHEMA (additionalProperties: false).
 */
export function serializeFormStructure(structure) {
    return {
        name: (structure?.name || "").trim(),
        criteria: (structure?.criteria || []).map((criterion) => ({
            name: (criterion.name || "").trim(),
            weight: Number(criterion.weight) || 1,
            criteria_state_type: Number(criterion.criteria_state_type),
            add_description: Boolean(criterion.add_description),
            add_upload_file: Boolean(criterion.add_upload_file),
            states: (criterion.states || []).map((state) => ({
                name: (state.name || "").trim(),
                emoji: state.emoji || "",
                value: Number(state.value),
            })),
        })),
    };
}

export function validateFormStructure(structure) {
    if (!structure?.name?.trim() || !structure?.criteria?.length) {
        return t("ai.form.preview.required");
    }
    const invalidCriterion = structure.criteria.some(
        (criterion) =>
            !criterion.name?.trim() ||
            Number(criterion.weight) <= 0 ||
            criterion.states.length < 2 ||
            criterion.states.some(
                (state) =>
                    !state.name?.trim() ||
                    !Number.isInteger(Number(state.value))
            )
    );
    if (invalidCriterion) {
        return t("ai.form.preview.invalid");
    }
    return "";
}

/**
 * Map a feedback Form API payload into the shared survey builder structure.
 * Source form ids stay behind so saving creates a survey copy, not an update.
 */
export function feedbackFormToSurveyStructure(form) {
    const criteria = form?.criteria_list || form?.criteria || [];
    return {
        name: (form?.name || "").trim(),
        criteria: criteria.map((criterion) => ({
            name: (criterion.criteria?.name || criterion.name || "").trim(),
            weight: Number(criterion.weight) || 1,
            criteria_state_type: criterion.criteria_state_type,
            add_description: Boolean(criterion.add_description),
            add_upload_file: Boolean(criterion.add_upload_file),
            states: (criterion.states || []).map((state) => ({
                name: (state.name || "").trim(),
                emoji: state.emoji || "",
                value: Number(state.value),
            })),
        })),
    };
}
